module.exports = __webpack_public_path__ + "img/SL.890bdc29.svg";